import Vue from 'vue/dist/vue.js';


export default {
    name : 'header',

    init()
    {
        const el = document.getElementById('header');

        if (el) {
            this.run(el);
        }
    },
    run (el)
    {
        new Vue({
            el : '#header',
            delimiters: ['@{', '}'],
            data :
            {
                items : null,
                mainMenuToggled : false,
                menuToggled : false,
                searchToggled : false,
                link  : "",
            },

            computed : {

                searchToggledCss()
                {
                    return (this.searchToggled) ? ' active ' : '';
                },

                mainMenuToggledCss()
                {
                    return (this.mainMenuToggled) ? ' toggled ' : '';
                },

                headerToggledCss()
                {
                    return (this.menuToggled || this.mainMenuToggled) ? ' toggled ' : '';
                },

                navMenuCss()
                {
                    return (this.menuToggled) ? ' active ' : '';
                },
            },

            methods :
            {
                toggleSearch()
                {
                    this.searchToggled = ! this.searchToggled;
                },

                hideSearch()
                {
                    this.searchToggled = false;
                },

                showSubMenu(index, event)
                {
                    const node = document.querySelector('.main-menu__nav-item--'+index);

                    if (node.classList.contains('has-submenu')) {
                        event.preventDefault();

                        if (node.classList.contains('active')) {
                            // remove if was active
                            node.classList.remove('active')
                        } else {
                            // remove from all
                            const all = document.querySelectorAll('.main-menu__nav-item');
                            all.forEach((i) => i.classList.remove('active'));
                            // add to active
                            node.classList.add('active');
                        }
                    }
                },

                hideAllSublayers()
                {
                    const el = document.querySelectorAll('.main-menu__nav-item.has-submenu');
                    el.forEach((item) => item.classList.remove('active'));
                },

                hideHeaderMenu(event)
                {
                    if (event.target.classList.contains('main-menu__nav')) {
                        this.toggleHeaderMenu();
                    }
                },

                toggleHeaderMenu(event)
                {
                    if (typeof event === 'object' && event !== null) {
                      event.preventDefault();
                    }
                    this.hideAllSublayers();
                    this.menuToggled = ! this.menuToggled;
                },

                toggleMainMenu()
                {
                    // console.log('toggleMainMenu');
                    this.mainMenuToggled = ! this.mainMenuToggled;
                }

            },

            created ()
            {
                // console.log('nav created... ');
            }
        });
    }

}